import { BfiCustomStore } from '@apply/ui';
import { Item } from 'devextreme-react/tab-panel';
import PrincipalApplicationsTable from '../../../tables/PrincipalApplicationsTable';

interface IApplicationTabParameters {
    title: string;
    selectedTabIndex: number;
    principalId: number;
    applicationsStore: BfiCustomStore;
}

export const ApplicationTab: React.FC<IApplicationTabParameters> = ({
    title,
    selectedTabIndex,
    principalId,
    applicationsStore,
}) => {
    return (
        <Item title={title}>
            <div
                style={{
                    width: '100%',
                    minHeight: '700px',
                }}
            >
                <PrincipalApplicationsTable
                    principalId={selectedTabIndex === 2 ? principalId : null}
                    gridStore={applicationsStore}
                />
            </div>
        </Item>
    );
};
